const resetClientStore = async () => {
  // Lazy import to avoid circular dependency
  const store = (await import("./store")).default;
  const { persistor } = await import("./store");

  store.dispatch({ type: "RESET_CLIENT_STORE" });

  await persistor.purge();
};

export default resetClientStore;
